module.exports = __webpack_public_path__ + "static/Ramifi-75c6982617d70175f5e44e3300762c6b.png";